import { Separator as SeparatorPrimitive } from "radix-ui"
import type { ComponentProps } from "react"
import { cn } from "cn"

// Figma „Separator“ ist eine 1px-Linie in `Separators/Non-opaque`. Figma
// zeigt nur die horizontale Ausrichtung; `orientation="vertical"` kommt
// vom Radix-/shadcn-Unterbau und ist rein additiv.
function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  ...props
}: ComponentProps<typeof SeparatorPrimitive.Root>) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "shrink-0 bg-separators-non-opaque data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        className
      )}
      {...props}
    />
  )
}

export { Separator }
